import { render, staticRenderFns } from "./VectorIcon.vue?vue&type=template&id=ffa8f0c4"
import script from "./VectorIcon.vue?vue&type=script&lang=js"
export * from "./VectorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports